import { Grid } from "@mui/material";
import { Box } from "@mui/system";
import React from "react";
import { useTranslation } from "react-i18next";
import { useQuery } from "react-query";
import styled from "styled-components/macro";
import Header from "../../components/custom/Header";
import { getAllProducts } from "../../services/upgradeYourPlan";
import UpgradePlanCard from "./UpgradePlanCard";

function UpgradePlan() {
  const { t } = useTranslation();
  const { data: getAllProductsData } = useQuery(
    "getAllProducts",
    getAllProducts
  );

  return (
    <>
      <StyledContainer sx={{ p: { xs: 2, md: 10 } }}>
        <Header
          name={t("Upgrade your plan")}
          productShow={false}
          upgradePlan={true}
        />

        <BodyWrapper>
          {getAllProductsData?.map((product) => {
            return <UpgradePlanCard data={product} key={product.id} />;
          })}
        </BodyWrapper>
      </StyledContainer>
    </>
  );
}

const StyledContainer = styled(Grid)`
  width: 100%;
  height: 100%;
`;

const BodyWrapper = styled(Box)`
  width: 100%;
  height: 85%;
  overflow-y: auto;
  margin-top: 2rem;
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  &::-webkit-scrollbar {
    width: 0.5rem;
  }
  &::-webkit-scrollbar-thumb {
    background-color: #babac0;
    border-radius: 16px;
  }
  &::-webkit-scrollbar-button {
    display: none;
  }
`;
export default UpgradePlan;
